import { CurrencyProps } from '$shared/components/Currency/Currency.interface';
import { useMemo } from 'react';
import { formatCurrency } from '$utils';

export const Currency = ({
  amount,
  currency,
  precise = 2,
  nearly = false,
  symbol = true,
  className,
}: CurrencyProps) => {
  const formattedAmount = useMemo(() => {
    const precisedAmount = formatCurrency(amount, currency, { symbol, precise });
    const groupingPattern = /\B(?=(\d{3})+(?!\d))/g;

    if (precisedAmount.includes('.')) {
      const [decimalPart, fractionalPart] = precisedAmount.split('.');

      return `${decimalPart.replace(groupingPattern, '\u00A0')}.${fractionalPart}`;
    }

    return precisedAmount.replace(groupingPattern, '\u00A0');
  }, [amount, precise]);

  return (
    <span className={className}>
      {nearly ? '≈ ' : ''}
      {formattedAmount}
    </span>
  );
};
